// Site operates in two explicit modes, flagged in the URL:
//   /vallalati  (corporate)             — mode "vallalati"
//   /lakossagi  (retail hub + products) — mode "lakossagi"
// The retail products live nested under /lakossagi/... so the mode is always
// visible in the address bar. "/" itself renders the lakossági home (see
// isRetailPath below) — DEFAULT_MODE only backstops corporate-only pages and
// neutral-page sticky fallback, not the root route.
export const MODE_CORPORATE = "vallalati";
export const MODE_RETAIL = "lakossagi";
export const DEFAULT_MODE = MODE_CORPORATE;

export const CORPORATE_HOME = "/vallalati";
export const RETAIL_HOME = "/lakossagi";

// Retail product routes (nested under the /lakossagi hub).
export const RETAIL_ROUTES = {
  jelzaloghitel: "/lakossagi/jelzaloghitel",
  szemelyiKolcson: "/lakossagi/szemelyi-kolcson",
  bankszamla: "/lakossagi/bankszamla",
  nyugdijmegtakaritas: "/lakossagi/nyugdijmegtakaritas",
  eletbiztositas: "/lakossagi/eletbiztositas",
};

// Legacy flat paths kept as redirects to the nested equivalents, so old
// bookmarks / links keep working.
export const LEGACY_REDIRECTS = {
  "/jelzaloghitel": RETAIL_ROUTES.jelzaloghitel,
  "/szemelyi-kolcson": RETAIL_ROUTES.szemelyiKolcson,
  "/lakossagi-bankszamla": RETAIL_ROUTES.bankszamla,
};

// Any path under these prefixes is treated as lakossági (retail). The old flat
// paths are included so the theme stays correct during their redirect frame.
const RETAIL_PREFIXES = [
  "/lakossagi",
  "/jelzaloghitel",
  "/szemelyi-kolcson",
];

// Neutral pages belong to neither variant — they inherit the mode the visitor
// is currently in (whichever variant they navigated from), rather than forcing
// vállalati.
export const NEUTRAL_PATHS = [
  "/rolunk",
  "/impresszum",
  "/adatkezelesi-tajekoztato",
];

export function isRetailPath(pathname) {
  return (
    pathname === "/" ||
    RETAIL_PREFIXES.some((prefix) => pathname.startsWith(prefix))
  );
}

export function isNeutralPath(pathname) {
  return NEUTRAL_PATHS.includes(pathname);
}

// Resolve the explicit mode for a given path. Defaults to vállalati. Neutral
// paths return null so the caller can substitute the visitor's current
// (sticky) mode instead.
export function getMode(pathname) {
  if (isRetailPath(pathname)) return MODE_RETAIL;
  if (isNeutralPath(pathname)) return null;
  return DEFAULT_MODE;
}

// Resolve the effective mode for a path, given the visitor's current sticky
// mode (used for neutral pages). Never returns null.
export function resolveMode(pathname, stickyMode) {
  const explicit = getMode(pathname);
  if (explicit) return explicit;
  return stickyMode || DEFAULT_MODE;
}
